import allTokens from './dist/design-tokens.nested.json';
export const { palette, ...tokens } = allTokens;
